{
    "color": {
        "main colors": {
            "tao-primary": {
                "description": "",
                "type": "color",
                "value": "#003366ff",
                "blendMode": "normal"
            },
            "tao-main-dark": {
                "description": "",
                "type": "color",
                "value": "#a5c4f2ff",
                "blendMode": "normal"
            },
            "tao-main-medium": {
                "description": "",
                "type": "color",
                "value": "#d4e5ffff",
                "blendMode": "normal"
            },
            "tao-main-light": {
                "description": "",
                "type": "color",
                "value": "#ebf3ffff",
                "blendMode": "normal"
            },
            "tao-main-thin": {
                "description": "",
                "type": "color",
                "value": "#f9fcffff",
                "blendMode": "normal"
            },
            "tao-white": {
                "description": "",
                "type": "color",
                "value": "#fefefeff",
                "blendMode": "normal"
            },
            "tao-black": {
                "description": "",
                "type": "color",
                "value": "#000000ff",
                "blendMode": "normal"
            },
            "tertiary": {
                "description": "",
                "type": "color",
                "value": "#f96900ff",
                "blendMode": "normal"
            },
            "tao-input-disabled": {
                "description": "",
                "type": "color",
                "value": "#edeff2ff",
                "blendMode": "normal"
            }
        },
        "text colors": {
            "tao-text-primary": {
                "description": "",
                "type": "color",
                "value": "#003366ff",
                "blendMode": "normal"
            },
            "tao-text-strong": {
                "description": "",
                "type": "color",
                "value": "#667788ff",
                "blendMode": "normal"
            },
            "tao-text-disabled": {
                "description": "",
                "type": "color",
                "value": "#7d7e7fff",
                "blendMode": "normal"
            }
        },
        "status colors": {
            "tao-info-dark": {
                "description": "",
                "type": "color",
                "value": "#014361ff",
                "blendMode": "normal"
            },
            "tao-info": {
                "description": "",
                "type": "color",
                "value": "#0f85ccff",
                "blendMode": "normal"
            },
            "tao-info-light": {
                "description": "",
                "type": "color",
                "value": "#71bbe8ff",
                "blendMode": "normal"
            },
            "tao-info-thin": {
                "description": "",
                "type": "color",
                "value": "#e5f6fdff",
                "blendMode": "normal"
            },
            "tao-success-dark": {
                "description": "",
                "type": "color",
                "value": "#1e4620ff",
                "blendMode": "normal"
            },
            "tao-success": {
                "description": "",
                "type": "color",
                "value": "#2e7d32ff",
                "blendMode": "normal"
            },
            "tao-success-light": {
                "description": "",
                "type": "color",
                "value": "#4caf50ff",
                "blendMode": "normal"
            },
            "tao-success-thin": {
                "description": "",
                "type": "color",
                "value": "#edf7edff",
                "blendMode": "normal"
            },
            "tao-warn-dark": {
                "description": "",
                "type": "color",
                "value": "#663c00ff",
                "blendMode": "normal"
            },
            "tao-warn": {
                "description": "",
                "type": "color",
                "value": "#ed6c02ff",
                "blendMode": "normal"
            },
            "tao-warn-light": {
                "description": "",
                "type": "color",
                "value": "#ffa62aff",
                "blendMode": "normal"
            },
            "tao-warn-thin": {
                "description": "",
                "type": "color",
                "value": "#fff4e5ff",
                "blendMode": "normal"
            },
            "tao-error-dark": {
                "description": "",
                "type": "color",
                "value": "#5f2120ff",
                "blendMode": "normal"
            },
            "tao-error": {
                "description": "",
                "type": "color",
                "value": "#d32f2fff",
                "blendMode": "normal"
            },
            "tao-error-light": {
                "description": "",
                "type": "color",
                "value": "#ffd2d9ff",
                "blendMode": "normal"
            },
            "tao-error-thin": {
                "description": "",
                "type": "color",
                "value": "#fff4f6ff",
                "blendMode": "normal"
            },
            "tao-accent": {
                "description": "",
                "type": "color",
                "value": "#d32f2fff",
                "blendMode": "normal"
            },
            "tao-validation": {
                "description": "",
                "type": "color",
                "value": "#ffd2d9ff",
                "blendMode": "normal"
            },
            "tao-validation-dark": {
                "description": "",
                "type": "color",
                "value": "#e57373ff",
                "blendMode": "normal"
            },
            "tao-validation-light": {
                "description": "",
                "type": "color",
                "value": "#ffeaedff",
                "blendMode": "normal"
            },
            "tao-validation-thin": {
                "description": "",
                "type": "color",
                "value": "#fff4f6ff",
                "blendMode": "normal"
            },
            "tao-gray": {
                "description": "",
                "type": "color",
                "value": "#d8c8c8ff",
                "blendMode": "normal"
            },
            "tao-disabled": {
                "description": "",
                "type": "color",
                "value": "#757575ff",
                "blendMode": "normal"
            }
        }
    }
}